import type { Snapshot } from '../types';

interface Props {
  snapshot: Snapshot;
}

function stat(label: string, value: any, suffix = '') {
  if (value === undefined || value === null) return null;
  return (
    <div className="stat-row" key={label}>
      <span className="stat-label">{label}</span>
      <span className="stat-value">
        {typeof value === 'number' ? Math.round(value * 100) / 100 : String(value)}
        {suffix}
      </span>
    </div>
  );
}

export function StatsPanel({ snapshot }: Props) {
  const s = snapshot.stats || {};
  const r = s.ratings || {};

  return (
    <div className="stats-panel">
      <section>
        <h3>Attributes</h3>
        {stat('Strength', s.str)}
        {stat('Agility', s.agi)}
        {stat('Stamina', s.sta)}
        {stat('Intellect', s.int)}
        {stat('Spirit', s.spi)}
      </section>

      <section>
        <h3>Offense</h3>
        {stat('Attack Power', s.attackPower)}
        {stat('Ranged AP', s.rangedAttackPower)}
        {stat('Spell Power', s.spellPower)}
        {stat('Melee Crit', s.critMeleePct, '%')}
        {stat('Spell Crit', s.critSpellPct, '%')}
        {stat('Hit Rating (melee)', r.hitMelee)}
        {stat('Hit Rating (spell)', r.hitSpell)}
        {stat('Haste Rating (melee)', r.hasteMelee)}
        {stat('Haste Rating (spell)', r.hasteSpell)}
        {stat('Expertise', r.expertise)}
        {stat('Armor Pen', r.armorPen)}
      </section>

      <section>
        <h3>Defense</h3>
        {stat('Armor', s.armor)}
        {stat('Defense', s.defense)}
        {stat('Dodge', s.dodgePct, '%')}
        {stat('Parry', s.parryPct, '%')}
        {stat('Block', s.blockPct, '%')}
      </section>
    </div>
  );
}
